import { OpenInNew } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { GenAlertDialog } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';
import { getShortOrderNumber } from '../../../../helpers/orders';

export default function NewOrderCreatedSuccessfully({
  open,
  onClose,
  vendorOrder,
}) {
  const { t } = useTranslation(['orders', 'global']);

  if (!vendorOrder) {
    return null;
  }

  const groupedServices = vendorOrder.relatedOrders.reduce(
    (prev, relatedOrder) => ({
      ...prev,
      [relatedOrder.services[0].type]: {
        woNumber: relatedOrder.woNumber,
        vendorOrderId: relatedOrder.vendorOrderId,
      },
    }),
    {}
  );

  return (
    <GenAlertDialog
      title={t('newOrder.saveSuccessfullyTitle')}
      closeText={t('close', { ns: 'global' })}
      titleVariant="h4"
      open={open}
      onClose={onClose}
    >
      <Stack alignItems="center" gap={2}>
        <Typography variant="Body1">
          {t('newOrder.saveSuccessfullyBody')}
        </Typography>
        <Stack gap={1}>
          {Object.entries(groupedServices).map(([key, workOrderNumber]) => (
            <Stack direction="row" justifyContent="center" alignItems="center">
              <Typography
                variant="overline"
                textTransform="uppercase"
                color="text.secondary"
              >
                {t(`newOrder.services.category.${key}`)} {t('workOrder')}:
              </Typography>
              <Button
                endIcon={<OpenInNew />}
                href={`/orders/${workOrderNumber.vendorOrderId}`}
                target="_blank"
              >
                {getShortOrderNumber(workOrderNumber.woNumber)}
              </Button>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </GenAlertDialog>
  );
}
